import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import FloatingCTA from './components/feature/FloatingCTA';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </BrowserRouter>
  );
}

export default App;
